"use client"

import Image from "next/image"
import React from "react"

const NeloLogo: React.FC = () => {
  return (
    <div className="flex flex-1 justify-center">
      <Image src="/images/nelo_logo_web.svg" alt="Nelo" className="h-10" width={120} height={40} />
    </div>
  )
}

export default NeloLogo
